import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, BookOpen, Search, TrendingUp } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Hero() {
  const scrollToContact = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const element = document.querySelector('#contact');
    if (element) {
      const offsetTop = element.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative pt-32 pb-20 md:pt-48 md:pb-32 overflow-hidden" data-id="element-59">
      {/* Soft gradient background */}
      <div className="absolute inset-0 bg-hero-pattern opacity-60 -z-10" data-id="element-60" />

      {/* Decorative blurred shapes */}
      <div className="absolute top-20 right-[-10%] w-[500px] h-[500px] rounded-full bg-sage-200/30 blur-[100px] -z-10" data-id="element-61" />
      <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] rounded-full bg-lavender-200/30 blur-[120px] -z-10" data-id="element-62" />

      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-63">
        <div className="max-w-4xl mx-auto text-center" data-id="element-64">
          <FadeIn data-id="element-65">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/60 border border-cream-200 backdrop-blur-sm mb-8" data-id="element-66">
              <span className="w-2 h-2 rounded-full bg-sage-300 animate-pulse" data-id="element-67" />
              <span className="text-sm font-medium text-slate-700" data-id="element-68">
                SEO & Content Marketing for E-Learning
              </span>
            </div>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-69">
            <h1 className="text-5xl md:text-7xl font-serif text-slate-900 leading-[1.1] mb-8 text-balance" data-id="element-70">
              Your E-Learning Platform Deserves to Be{' '}
              <span className="italic text-lavender-800" data-id="element-71">Found</span>.
            </h1>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-72">
            <p className="text-lg md:text-xl text-slate-600 mb-10 leading-relaxed max-w-2xl mx-auto text-balance" data-id="element-73">
              We help educational platforms rank higher, attract dedicated
              learners, and grow enrollments through academic-grade SEO and
              strategic content marketing.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-74">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-75">
              <a href="#contact" onClick={scrollToContact} className="group flex items-center gap-2 px-8 py-4 bg-slate-900 text-white rounded-full font-medium hover:bg-slate-800 transition-all hover:shadow-lg hover:shadow-slate-900/20" data-id="element-76">
                Explore Our Approach
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-77" />
              </a>
              <a href="#services" onClick={e => {
              e.preventDefault();
              document.querySelector('#services')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} className="px-8 py-4 text-slate-700 font-medium hover:text-slate-900 transition-colors" data-id="element-78">
                View Services
              </a>
            </div>
          </FadeIn>
        </div>

        {/* Decorative academic elements */}
        <FadeIn delay={0.5} className="mt-20 md:mt-32" data-id="element-79">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto" data-id="element-80">
            {[{
            icon: Search,
            text: 'Semantic Search Architecture',
            color: 'bg-sage-100/50 text-sage-900'
          }, {
            icon: BookOpen,
            text: 'Curriculum-Aligned Content',
            color: 'bg-lavender-100/50 text-lavender-900'
          }, {
            icon: TrendingUp,
            text: 'Enrollment Growth Analytics',
            color: 'bg-blue-100/50 text-blue-900'
          }].map((item, i) => <div key={i} className={`flex items-center gap-4 p-4 rounded-2xl backdrop-blur-sm border border-white/40 ${item.color}`} data-id="element-81">
                <div className="p-3 bg-white/60 rounded-xl" data-id="element-82">
                  <item.icon size={20} data-id="element-83" />
                </div>
                <span className="font-medium text-sm" data-id="element-84">{item.text}</span>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}